import { render, staticRenderFns } from "./SearchTool.vue?vue&type=template&id=3c97d7c7&scoped=true"
import script from "./SearchTool.vue?vue&type=script&lang=js"
export * from "./SearchTool.vue?vue&type=script&lang=js"
import style0 from "./SearchTool.vue?vue&type=style&index=0&id=3c97d7c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c97d7c7",
  null
  
)

export default component.exports